import { Navigate } from "react-router";
import { useOnboardingCompleted } from "@/caregiver-app/hooks/useOnboardingCompleted";

export function OnboardingGuard({ children }: { children: React.ReactNode }) {
	const { needsOnboarding } = useOnboardingCompleted();

	if (needsOnboarding) {
		return <Navigate to="/app/onboarding" replace />;
	}

	return children;
}
